import { withStyles } from '@material-ui/core/styles'
import styles from './HomePage.styles'

export default withStyles(styles)
